<template>
    <el-dialog :title="$t('categories.dialog_title')" :visible.sync="showPopup" append-to-body  class="my-dialog-class">
        
        <el-form :label-position="'top'" 
        :inline="false"  label-width="100%"  
        :model='selectedObject'  
        :rules="rules"
        ref='my-form' @submit.prevent="save" v-loading="loading">
             <el-row :gutter="15">

                 <el-col :span="12">
                    <el-form-item :label="$t('categories.name')" prop="Name" :required="true">
                        <el-input v-model="selectedObject.Name"  autofocus></el-input>
                    </el-form-item>
                 </el-col>

                 <el-col :span="12">
                    <el-form-item :label="$t('categories.old_product_price')" prop="OldProductPrice" :required="true">
                        <el-input-number v-model="selectedObject.OldProductPrice"></el-input-number>
                    </el-form-item>
                 </el-col>

             </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="save">{{ $t("confirm") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import settings from "./../../backend/LocalSettings";

export default {
  name: "category-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      mode: 'add',
      selectedObject: {},
      request_new_mode: 0,
      rules: {
          Name:            [ { required: true, message: this.$t('products.required_name') } ],
          OldProductPrice: [ { required: true, message: this.$t('products.required_old_product_price') } ],
      }
    }
    
  },
  methods: {
     show_me: function( selectedObject, request_new_mode = 0  ) {
         this.mode = "edit";
        if( selectedObject == null ) {
            selectedObject = { OldProductPrice: 10 };
            this.mode = "add";
        }
        this.request_new_mode = request_new_mode;
        this.showPopup        = true;
        this.selectedObject   = JSON.parse( JSON.stringify( selectedObject ) );
    },
    load_info: function(){
        //aici incarcam dropdownuri sau alte elemente, la nevoie
    },
    save: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
            .post('categories/save',  { mode: this.mode, object: this.selectedObject, request_new_mode: this.request_new_mode } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                this.showPopup = false;
                this.$emit("save");
                } else {
                this.$router.push("/");
                }
            });
          }
        });
    }
  },
  mounted: function() {
      this.load_info();
  }
};
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }
</style>